import myaxios from '@/myaxios.js'
function SetSurgeryInfoExtraDatas(extendColumnList, obj, data) {
    if (extendColumnList && extendColumnList.length > 0) {
        let extradata = []
        _.forEach(extendColumnList, b => {
            if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                if (data[b.data_key]) {
                    extradata.push({ "DataKey": b.data_key, "DataValue": JSON.stringify(eval(data[b.data_key])) })
                } else {
                    extradata.push({ "DataKey": b.data_key, "DataValue": `` })
                }
            } else if (b.data_type == `multiselect`) {
                extradata.push({ "DataKey": b.data_key, "DataValue": data[b.data_key] && data[b.data_key].join(`,`) })
            } else {
                extradata.push({ "DataKey": b.data_key, "DataValue": data[b.data_key] })
            }
        })
        obj.extra_datas = extradata
    }
}

function SetSurgeryInfoObj(extendColumnList, obj, data) {
    if (extendColumnList && extendColumnList.length > 0) {
        _.forEach(extendColumnList, b => {
            let mc = _.find(data.extra_datas, f => f.DataKey == b.data_key)
            if (mc) {
                if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                    obj[b.data_key] = mc[`DataValue`] != `` ? JSON.parse(mc[`DataExtraValue`]) : ``
                } else if (b.data_type == `multiselect`) {
                    obj[b.data_key] = mc[`DataValue`] && mc[`DataValue`].split(`,`)
                } else {
                    obj[b.data_key] = b.data_type == `checkbox` ? JSON.parse(mc[`DataValue`]) : mc[`DataValue`]
                }
            } else {
                obj[b.data_key] = null
            }
        })
    }
}

// 返回个性化分组
function SetExtraColumnListToEdit(extendColumnList) {
    let listextends = []
    // 显示扩展动态列----动态渲染Begin
    if (extendColumnList && extendColumnList.length > 0) {
        // 开始进行分组Begin

        // 有分组的列表
        let hasgroup = _.filter(extendColumnList, d => { return d.data_group_name != null && d.data_group_name != `` && d.is_editable === true }).sort((a, b) => a.display_order - b.display_order)
        // 遍历分组的列表，追加到手术信息后面
        if (hasgroup.length > 0) {
            // 分组
            let exlistBygroup = _.groupBy(hasgroup, `data_group_name`)
            // 遍历分组
            _.reduce(
                exlistBygroup,
                function(result, array, key) {
                    let listextend = { obj: {}, items: [] }
                    // 添加分组栏
                    listextend.obj = {
                        type: `p`,
                        prop: `${key}`,
                        isCreatable: true,
                        isEditable: true,
                        placeholder: `${key}`,
                        colspan: 24,
                        area: [1, 2],
                        label: { content: ` `, position: `top` }
                    }

                    // 添加当前分组对应的明细
                    _.forEach(array.sort((a, b) => a.display_order - b.display_order), b => {
                        // checkbox类型的无法直接显示在list里面，特殊处理，一个checkbox显示2字段，一个select类型放到list，一个checkbox放到edit
                        if (b.data_type == `checkbox`) {
                            // 渲染checkbox类型放到edit
                            listextend.items.push({
                                type: b.data_type,
                                prop: b.data_key,
                                options: b.data_type == `select` ? JSON.parse(b.data_option) : null,
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                readonly: b.data_read_only,
                                isCreatable: b.is_creatable,
                                isEditable: b.is_editable
                            })
                        } else if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                            // 直接渲染未分组的字段
                            listextend.items.push({
                                type: b.data_type,
                                prop: b.data_key,
                                collapseTags: false,
                                options: (that, { row }) => {
                                    return q => {
                                        let r = myaxios.get(`/api/AcisSystem/SurgeryInfoExtraParam/SearchOptionsByKey?sql=${b.data_option}`, q)
                                        return r
                                    }
                                },
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                readonly: b.data_read_only,
                                isCreatable: b.is_creatable,
                                isEditable: b.is_editable
                            })
                        } else {
                            // 直接渲染未分组的字段
                            listextend.items.push({
                                type: b.data_type,
                                prop: b.data_key,
                                options: (b.data_type == `select` || b.data_type == `multiselect`) ? JSON.parse(b.data_option) : null,
                                config: {
                                    allowCreate: true
                                },
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                readonly: b.data_read_only,
                                collapseTags: false,
                                isCreatable: b.is_creatable,
                                isEditable: b.is_editable
                            })
                        }
                    })

                    listextends.push(listextend)
                },
                []
            )
        }
    }
    return listextends
}

function SetExtraColumnList(extendColumnList, list) {
    // 显示扩展动态列----动态渲染Begin
    if (extendColumnList && extendColumnList.length > 0) {
        // 开始进行分组Begin
        let listextend = []
        // 未分组的列表
        let nogroup = _.filter(extendColumnList, d => { return d.data_group_name == null || d.data_group_name == `` }).sort((a, b) => a.display_order - b.display_order)
        // 有分组的列表
        let hasgroup = _.filter(extendColumnList, d => { return d.data_group_name != null && d.data_group_name != `` }).sort((a, b) => a.display_order - b.display_order)
        // 先遍历未分组的列表，追加到手术信息里面
        if (nogroup.length > 0) {
            _.forEach(nogroup.sort((a, b) => a.display_order - b.display_order), b => {
                // checkbox类型的无法直接显示在list里面，特殊处理，一个checkbox显示2字段，一个select类型放到list，一个checkbox放到edit
                if (b.data_type == `checkbox`) {
                    // 渲染成select类型放到list
                    listextend.push({
                        type: `select`,
                        prop: b.data_key,
                        options: `enum_bool`,
                        label: `${b.show_name}`,
                        width: `100`,
                        colspan: b.data_colspan,
                        area: [1, 2],
                        isCreatable: false,
                        isEditable: false,
                        searchable: b.is_searchable,
                        isListable: b.is_listable
                    })
                    // 渲染checkbox类型放到edit
                    listextend.push({
                        type: b.data_type,
                        prop: b.data_key,
                        options: b.data_type == `select` ? JSON.parse(b.data_option) : null,
                        label: `${b.show_name}`,
                        width: `100`,
                        colspan: b.data_colspan,
                        area: [1, 2],
                        readonly: b.data_read_only,
                        isCreatable: b.is_creatable,
                        isEditable: b.is_editable
                    })
                } else if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                    // 直接渲染未分组的字段
                    listextend.push({
                        type: b.data_type,
                        prop: b.data_key,
                        collapseTags: false,
                        options: (that, { row }) => {
                            return q => {
                                let r = myaxios.get(`/api/AcisSystem/SurgeryInfoExtraParam/SearchOptionsByKey?sql=${b.data_option}`, q)
                                return r
                            }
                        },
                        label: `${b.show_name}`,
                        width: `100`,
                        colspan: b.data_colspan,
                        area: [1, 2],
                        readonly: b.data_read_only,
                        isCreatable: b.is_creatable,
                        searchable: b.is_searchable,
                        isEditable: b.is_editable
                    })
                } else {
                    if (b.is_listable) {
                        // 直接渲染未分组的字段
                        listextend.push({
                            type: b.data_type,
                            prop: b.data_key,
                            collapseTags: false,
                            options: (b.data_type == `select` || b.data_type == `multiselect`) ? JSON.parse(b.data_option) : null,
                            config: {
                                allowCreate: true
                            },
                            label: `${b.show_name}`,
                            width: `100`,
                            colspan: b.data_colspan,
                            area: [1, 2],
                            searchable: b.is_searchable,
                            isListable: true
                        })
                    }
                    // 直接渲染未分组的字段
                    listextend.push({
                        type: b.data_type,
                        prop: b.data_key,
                        collapseTags: false,
                        showCount: 10,
                        options: (b.data_type == `select` || b.data_type == `multiselect`) ? JSON.parse(b.data_option) : null,
                        config: {
                            allowCreate: true
                        },
                        label: `${b.show_name}`,
                        width: `100`,
                        colspan: b.data_colspan,
                        area: [1, 2],
                        readonly: b.data_read_only,
                        isCreatable: b.is_creatable,
                        isEditable: b.is_editable
                    })
                }
            })
        }
        // 遍历分组的列表，追加到手术信息后面
        if (hasgroup.length > 0) {
            // 分组
            let exlistBygroup = _.groupBy(hasgroup, `data_group_name`)
            // 遍历分组
            _.reduce(
                exlistBygroup,
                function(result, array, key) {
                    let r1 = _.cloneDeep(array)
                    let r2 = _.cloneDeep(array)
                    r1 = _.filter(r1, d => {
                        return d.is_creatable === true
                    })
                    r2 = _.filter(r2, d => {
                        return d.is_editable === true
                    })
                    if ((r1 && r1.length > 0) || (r2 && r2.length > 0)) {
                        // 添加分组栏
                        listextend.push({
                            type: `p`,
                            prop: `title1`,
                            isCreatable: r1 && r1.length > 0,
                            isEditable: r2 && r2.length > 0,
                            placeholder: `　${key}`,
                            colspan: 24,
                            area: [1, 2],
                            label: { content: ` `, position: `top` }
                        })
                    }
                    // 添加当前分组对应的明细
                    _.forEach(array.sort((a, b) => a.display_order - b.display_order), b => {
                        // checkbox类型的无法直接显示在list里面，特殊处理，一个checkbox显示2字段，一个select类型放到list，一个checkbox放到edit
                        if (b.data_type == `checkbox`) {
                            // 渲染select类型放到list
                            listextend.push({
                                type: `select`,
                                prop: b.data_key,
                                options: `enum_bool`,
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                isCreatable: false,
                                isEditable: false,
                                searchable: b.is_searchable,
                                isListable: b.is_listable
                            })
                            // 渲染checkbox类型放到edit
                            listextend.push({
                                type: b.data_type,
                                prop: b.data_key,
                                options: b.data_type == `select` ? JSON.parse(b.data_option) : null,
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                readonly: b.data_read_only,
                                isCreatable: b.is_creatable,
                                isEditable: b.is_editable
                            })
                        } else if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                            // 直接渲染未分组的字段
                            listextend.push({
                                type: b.data_type,
                                prop: b.data_key,
                                collapseTags: false,
                                options: (that, { row }) => {
                                    return q => {
                                        let r = myaxios.get(`/api/AcisSystem/SurgeryInfoExtraParam/SearchOptionsByKey?sql=${b.data_option}`, q)
                                        return r
                                    }
                                },
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                readonly: b.data_read_only,
                                searchable: b.is_searchable,
                                isCreatable: b.is_creatable,
                                isEditable: b.is_editable
                            })
                        } else {
                            // 直接渲染当前分组下的字段
                            if (b.is_listable) {
                                // 直接渲染未分组的字段
                                listextend.push({
                                    type: b.data_type,
                                    prop: b.data_key,
                                    collapseTags: false,
                                    options: (b.data_type == `select` || b.data_type == `multiselect`) ? JSON.parse(b.data_option) : null,
                                    config: {
                                        allowCreate: true
                                    },
                                    label: `${b.show_name}`,
                                    width: `100`,
                                    colspan: b.data_colspan,
                                    area: [1, 2],
                                    searchable: b.is_searchable,
                                    isListable: true
                                })
                            }
                            // 直接渲染未分组的字段
                            listextend.push({
                                type: b.data_type,
                                prop: b.data_key,
                                collapseTags: false,
                                options: (b.data_type == `select` || b.data_type == `multiselect`) ? JSON.parse(b.data_option) : null,
                                config: {
                                    allowCreate: true
                                },
                                label: `${b.show_name}`,
                                width: `100`,
                                colspan: b.data_colspan,
                                area: [1, 2],
                                readonly: b.data_read_only,
                                isCreatable: b.is_creatable,
                                isEditable: b.is_editable
                            })
                        }
                    })
                },
                []
            )
        }
        // 如果有需要显示的动态字段，则合并到list
        if (listextend.length > 0) {
            list = list.concat(listextend)
        }
    }
    return list
    // 显示扩展动态列----动态渲染End
}
function SetOtherSettingColumn(list, OtherSettingColumn, applicationtype = 1) {
    if (OtherSettingColumn && OtherSettingColumn.length > 0) {
        let realyonlylist = _.filter(OtherSettingColumn, d => { return d.is_read_only == true && d.enum_application_type == applicationtype })
        let requiredlist = _.filter(OtherSettingColumn, d => { return d.is_required == true && d.enum_application_type == applicationtype })
        let hasfieldstylelist = _.filter(OtherSettingColumn, d => { return d.field_style != null && d.field_style != `` && d.enum_application_type == applicationtype })
        _.forEach(list, b => {
            var colrealyonly = _.find(realyonlylist, c => b.label == c.column_name)
            if (colrealyonly) {
                b.readonly = true
            } else {
                // 未设置自定义只读字段一律将新增列字段中只读移除
                b.readonly = false
            }
            var colrequired = _.find(requiredlist, c => b.label == c.column_name)
            if (colrequired) {
                b.validate = [{ required: true, message: `必填项目`, trigger: `blur` }]
            } else {
                // 未设置自定义必填字段一律将新增列字段中必填移除
                b.validate = null
            }
            var colhasfieldstyle = _.find(hasfieldstylelist, c => b.label == c.column_name)
            if (colhasfieldstyle && (b.isEditable == true || b.isCreatable == true)) {
                b.field_style = colhasfieldstyle.field_style
            }
        })
    }
    return list
}
function objectsAreEqual(obj1, obj2) {
    // 基本类型比较
    if (obj1 === obj2) return true
    if ((obj1 == null && obj2 == undefined) || (obj1 == undefined && obj2 == null)) {
        return true
    }
    // 判断类型是否相同
    if (typeof obj1 !== typeof obj2) return false

    // 如果不是对象或数组，则直接比较值
    if (typeof obj1 !== `object`) return false

    // 数组或对象比较
    const keys = Object.keys(obj2)

    // if (keys1.length !== keys2.length) return false
    let flag = false
    for (let key of keys) {
        if (key !== `origion` && key !== `___index` && key !== `___sequence_no`) {
            if (!this.objectsAreEqual(obj1[key], obj2[key])) {
                console.log(key, `不一致`)
                console.log(obj1[key], obj2[key])
                flag = true
                break
            }
        }
    }
    if (flag === true) {
        return false
    }
    return true
}
export default { SetOtherSettingColumn, SetExtraColumnListToEdit, SetSurgeryInfoExtraDatas, SetSurgeryInfoObj, SetExtraColumnList, objectsAreEqual }



// WEBPACK FOOTER //
// ./src/common/SurgeryInfoExtraParamUtil.js